export default {
  'pages.layouts.userLayout.title':
    'AI Dovut is a project of JURAT focused on content analysis and generation',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.tab.login': 'Sign In',
  'pages.login.accountLogin.errorMessage': 'Incorrect login/password(admin@gmail.com/ai.dovut)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.login.label': 'Login',
  'pages.login.login.placeholder': 'Enter your login',
  'pages.login.login.required': 'Please input your login!',
  'pages.login.login.invalid': 'Invalid login format!',
  'pages.login.password.label': 'Password',
  'pages.login.password.placeholder': 'Enter your password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.password.min': 'Password must be at least 6 characters',
  'pages.login.password.max': 'Password cannot exceed 20 characters',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  //signup
  'pages.signup.tab': 'Sign Up',
  'pages.signup.login.placeholder': 'Enter your login',
  'pages.signup.login.required': 'Please input your login!',
  'pages.signup.login.invalid': 'Invalid login format!',
  'pages.signup.name.label': 'Name',
  'pages.signup.name.placeholder': 'What is your name?',
  'pages.signup.name.required': 'Please input your name!',
  'pages.signup.name.max': 'Name cannot exceed 50 characters',
  'pages.signup.password.placeholder': 'Enter your password',
  'pages.signup.password.required': 'Please input your password!',
  'pages.signup.password.min': 'Password must be at least 6 characters',
  'pages.signup.password.max': 'Password cannot exceed 20 characters',
  'pages.signup.confirmPassword.label': 'Confirm password',
  'pages.signup.confirmPassword.placeholder': 'Enter your password',
  'pages.signup.confirmPassword.required': 'Please confirm your password!',
  'pages.signup.confirmPassword.mismatch': 'Passwords do not match!',
  'pages.signup.submit': 'Sign Up',
  'pages.signup.success': 'Sign up successful!',
  'pages.signup.failure': 'Sign up failed, please try again!',
  // Welcome page
  'pages.monitoring.communications': 'Communication search',
  'pages.monitoring.communicationDetails': 'Communication data',
  'pages.monitoring.focus': 'Opened from statistics: {user}',
  'pages.welcome.stats.title': 'Chat statistics',
  'pages.welcome.stats.users': 'Chat users',
  'pages.welcome.stats.avgResponse': 'Average response time',
  'pages.welcome.stats.textRequests': 'Text requests',
  'pages.welcome.stats.voiceRequests': 'Voice requests',
  'pages.welcome.stats.dynamics': 'Requests per day',
  'pages.welcome.stats.tooltip': 'text {text}, voice {voice}',
  'pages.welcome.stats.period': 'Period: {from} — {to}',
  'pages.welcome.stats.loadError': 'Failed to load chat statistics',
  'pages.welcome.stats.seconds': 's',
  'pages.welcome.recentUsers.title': 'Recent requests',
  'pages.welcome.recentUsers.empty': 'No chat requests yet',
  'pages.welcome.recentUsers.requests': 'Requests in period',
  'pages.welcome.recentUsers.channel.text': 'Text',
  'pages.welcome.recentUsers.channel.voice': 'Voice',
  'pages.welcome.title': 'Dashboard',
  'pages.welcome.description':
    'Chat overview: users, response time, text and voice requests, and recent conversations.',
  'pages.school.title': 'School',
  'pages.school.description':
    'Choose a country, region, city, school, role, and profile. The choice is saved and sent to the chat as parameters.',
  'pages.school.country': 'Country',
  'pages.school.region': 'Region',
  'pages.school.city': 'City',
  'pages.school.school': 'School',
  'pages.school.role': 'Role',
  'pages.school.class': 'Class',
  'pages.school.employee': 'Employee',
  'pages.school.student': 'Student',
  'pages.school.subject': 'Subject',
  'pages.school.profile': 'User',
  'pages.school.placeholder': 'Select',
  'pages.school.saved': 'Saved choice',
  'pages.school.savedHint': 'This JSON is sent to the chat together with the question.',
  'pages.school.empty': 'Nothing selected',
  'pages.school.clear': 'Clear choice',
  'pages.school.loadError': 'Failed to load school data',
  'pages.school.role.teacher': 'teacher',
  'pages.school.role.student': 'student',
  'pages.school.role.parent': 'parent',
  'pages.school.role.director': 'director',
  'pages.school.role.class_teacher': 'class teacher',
  'pages.school.role.employee': 'employee',
  'pages.welcome.chatInfo.title': 'Embedding the chat',
  'pages.welcome.chatInfo':
    'You can easily add this chat to any other page by simply importing the ChatDialog component.',
  'pages.welcome.chatFeatures.title': 'Chat Features',
  'pages.welcome.chatFeatures.textMessages': 'Send text messages',
  'pages.welcome.chatFeatures.fileUpload': 'Upload files',
  'pages.welcome.chatFeatures.messageHistory': 'Message history',
  'pages.welcome.chatFeatures.autoScroll': 'Automatic scroll to last message',
  'pages.welcome.chatFeatures.modalWindow': 'Modal window for convenient interaction',
  'pages.welcome.organization.title': 'Current organization',
  'pages.welcome.organization.select': 'Select organization context',
  'pages.welcome.organization.empty': 'No organization contexts available for this user',
  'pages.welcome.organization.fallback': 'Organization',
  'pages.welcome.organization.loadFailed': 'Failed to load organization contexts',
  'pages.welcome.organization.switchSuccess': 'Organization context switched successfully',
  'pages.welcome.organization.switchFailed': 'Failed to switch organization context',
  // List page
  'pages.list.uploadFiles': 'Upload Files',
  'pages.list.uploading': 'Uploading...',
  'pages.list.uploadedFiles': 'Uploaded Files',
  'pages.list.download': 'Download',
  // User Management
  'pages.users.loading': 'Loading user data...',
  'pages.users.fetchError': 'Failed to load users',
  'pages.users.noUserData': 'No user data available',
  'pages.users.userInformation': 'User Information',
  'pages.users.accountCreated': 'Account Created',
  'pages.users.lastUpdated': 'Last Updated',
  'pages.users.title': 'User Management',
  'pages.users.welcome': 'Welcome back, {name}! Manage users and system settings.',
  'pages.users.status': 'Status',
  'pages.users.actions': 'Actions',
  'pages.users.user': 'Users',
  'pages.users.active': 'Active',
  'pages.users.inactive': 'Inactive',
  'pages.users.editUser': 'Edit User',
  'pages.users.updateUser': 'Update user (by ID)',
  'pages.users.deleteUser': 'Delete user (by ID)',
  'pages.users.userIdRequired': 'Please enter user ID',
  'pages.users.userIdPlaceholder': 'Enter user ID',
  'pages.users.deleteConfirm': 'Are you sure you want to delete this user?',
  'pages.users.passwordPlaceholder': 'Leave blank to keep current password',
  'pages.users.emailPlaceholder': 'Enter email',
  'pages.users.emailRequired': 'Please enter email',
  'pages.users.emailInvalid': 'Invalid email format',
  'pages.users.nameRequired': 'Please enter name',
  'pages.users.roleRequired': 'Please select role',
  'pages.users.createNotImplemented': 'Create functionality not implemented yet',
  'pages.users.totalUsers': 'Total Users',
  'pages.users.statsError': 'Failed to load statistics',
  'pages.users.noMore': 'No more users to load',
  'pages.users.joined': 'Joined',
  'pages.usersCards.title': 'Users (Cards)',
  'pages.usersCards.welcome': 'Welcome back, {name}! Browse users in card view.',
  'pages.usersCards.totalUsers': 'Total Users',
  'pages.usersCards.statsError': 'Failed to load user statistics',
  'pages.usersCards.fetchError': 'Failed to load users',
  'pages.usersCards.loading': 'Loading users...',
  'pages.usersCards.noMore': 'No more users to load',
  'pages.usersCards.empty': 'No users found',

  // Role Management
  'pages.roles.title': 'Role Management',
  'pages.roles.role': 'Roles',
  'pages.roles.actions': 'Actions',
  'pages.roles.createRole': 'Create Role',
  'pages.roles.editRole': 'Edit Role',
  'pages.roles.updateRole': 'Update role (by ID)',
  'pages.roles.deleteRole': 'Delete role (by ID)',
  'pages.roles.roleIdRequired': 'Please enter role ID',
  'pages.roles.roleIdPlaceholder': 'Enter role ID',
  'pages.roles.deleteConfirm': 'Are you sure you want to delete this role?',
  'pages.roles.namePlaceholder': 'Enter role name',
  'pages.roles.slugPlaceholder': 'Enter role slug (e.g., admin, user)',
  'pages.roles.nameRequired': 'Please enter role name',
  'pages.roles.slugRequired': 'Please enter role slug',
  'pages.roles.admin': 'Admin',
  'pages.roles.user': 'User',

  // Subject Type Management
  'pages.subjectTypes.title': 'Subject Type Management',
  'pages.subjectTypes.actions': 'Actions',
  'pages.subjectTypes.createSubjectType': 'Create Subject Type',
  'pages.subjects.createSubject': 'Create Subject',
  'pages.searchTable.requiredField': 'This field is required',
  'pages.subjectTypes.updateSubjectType': 'Update Subject Type (by subject_type_id)',
  'pages.subjectTypes.editSubjectType': 'Edit Subject Type',
  'pages.subjectTypes.subjectTypeIdRequired': 'Please enter subject type ID',
  'pages.subjectTypes.subjectTypeIdPlaceholder': 'Enter subject type ID',
  'pages.subjectTypes.subjectTypeIdDeletePlaceholder': 'Enter subject type ID to delete',
  'pages.subjectTypes.deleteSubjectType': 'Delete Subject Type (by subject_type_id)',
  'pages.subjectTypes.deleteConfirm': 'Are you sure you want to delete this subject type?',
  'pages.subjectTypes.namePlaceholder': 'Enter subject type name',
  'pages.subjectTypes.slugPlaceholder': 'Enter subject type slug',
  'pages.subjectTypes.nameRequired': 'Please enter subject type name',
  'pages.subjectTypes.slugRequired': 'Please enter subject type slug',

  // Organization Management
  'pages.organizations.title': 'Organization Management',
  'pages.organizations.organizationIdRequired': 'Please enter subject ID',
  'pages.organizations.organizationIdPlaceholder': 'Enter subject ID',
  'pages.organizations.organizationIdDeletePlaceholder': 'Enter subject ID to delete',
  'pages.organizations.actions': 'Actions',
  'pages.organizations.createOrganization': 'Create Organization',
  'pages.organizations.updateOrganization': 'Update organization',
  'pages.organizations.editOrganization': 'Edit Organization',
  'pages.organizations.deleteOrganization': 'Delete organization',
  'pages.organizations.deleteConfirm': 'Are you sure you want to delete this organization?',
  'pages.organizations.loadError':
    'Failed to load organizations: server error (organization.type must be an object, not a UUID string).',
  'pages.organizations.detailsPlaceholder': '{"key":"value"}',
  'pages.organizations.detailsRequired': 'Please provide details JSON',

  // Common Table Actions
  'pages.searchTable.new': 'New',
  'pages.searchTable.edit': 'Edit',
  'pages.searchTable.delete': 'Delete',
  'pages.searchTable.reset': 'Reset',
  'pages.searchTable.query': 'Query',
  'pages.searchTable.yes': 'Yes',
  'pages.searchTable.no': 'No',
  'pages.searchTable.ok': 'OK',
  'pages.searchTable.cancel': 'Cancel',
  'pages.searchTable.createSuccess': 'Created successfully',
  'pages.searchTable.createError': 'Failed to create',
  'pages.searchTable.updateSuccess': 'Updated successfully',
  'pages.searchTable.updateError': 'Failed to update',
  'pages.searchTable.deleteSuccess': 'Deleted successfully',
  'pages.searchTable.deleteError': 'Failed to delete',
  'pages.searchTable.okWithCount': 'OK ({count})',
  'pages.searchTable.totalRange': '{start}-{end} of {total} items',
  'pages.searchTable.deleteInputRequired': 'Please enter {field}',
  'pages.searchTable.deleteInputPlaceholder': 'Enter the identifier to delete',

  // Placeholders
  'pages.searchTable.inputPlaceholder': 'Please enter',
  'pages.searchTable.selectPlaceholder': 'Please select',

  // @generated entity-pages
  'pages.aiModel.createAiModel': 'Create AI model',
  'pages.application.createApplication': 'Create Application',
  'pages.brokerEvent.createBrokerEvent': 'Create Broker event',
  'pages.communication.createCommunication': 'Create Communication',
  'pages.communicationDetail.createCommunicationDetail': 'Create Communication detail',
  'pages.communicationFolder.createCommunicationFolder': 'Create Communication folder',
  'pages.communicationHistory.createCommunicationHistory': 'Create Communication history',
  'pages.communicationPermission.createCommunicationPermission': 'Create Communication permission',
  'pages.communicationStrategy.createCommunicationStrategy': 'Create Communication strategy',
  'pages.communicationSubject.createCommunicationSubject': 'Create Communication subject',
  'pages.communicationVersion.createCommunicationVersion': 'Create Communication version',
  'pages.communicationView.createCommunicationView': 'Create Communication view',
  'pages.contextClassifier.createContext': 'Create Context classifier',
  'pages.contextData.createContextData': 'Create Context data item',
  'pages.contextPipeline.createContextPipeline': 'Create Context pipeline',
  'pages.contextStorage.createContextStorage': 'Create Context storage',
  'pages.dataPipeline.createDataPipeline': 'Create Data pipeline',
  'pages.dataPipelineDetail.createDataPipelineDetail': 'Create Data pipeline detail',
  'pages.dependentVersionService.createDependentVersionService': 'Create Dependent service version',
  'pages.detailScheduler.createDetailScheduler': 'Create Scheduler run detail',
  'pages.division.createDivision': 'Create Division',
  'pages.groupContextClassifier.createGroupContextClassifiers': 'Create Context classifier group',
  'pages.historyRunningPipeline.createHistoryRunningPipeline': 'Create Pipeline run history',
  'pages.historyRunningStreamPipeline.createHistoryRunningStreamPipeline':
    'Create Stream pipeline run history',
  'pages.individual.createIndividual': 'Create Individual',
  'pages.injectionVersionService.createInjectionVersionService': 'Create service version injection',
  'pages.organization.createOrganization': 'Create Organization',
  'pages.organizationPosition.createOrganizationPosition': 'Create Organization position',
  'pages.organizationStructure.createOrganizationStructure': 'Create Organizational structure',
  'pages.organizationStructurePermission.createOrganizationStructurePermissions':
    'Create Organization structure permission',
  'pages.permission.createPermission': 'Create Permission',
  'pages.pipeline.createPipeline': 'Create Pipeline',
  'pages.providerContext.createProviderContext': 'Create Provider context',
  'pages.providerContextClassifier.createProviderContextClassifiers':
    'Create Provider context classifier',
  'pages.resultContextClassifier.createResultContextClassifiers':
    'Create Result context classifier',
  'pages.resultScheduler.createResultScheduler': 'Create Scheduler job result',
  'pages.role.createRole': 'Create Role',
  'pages.running.createRunning': 'Create Run type',
  'pages.scheduler.createScheduler': 'Create Scheduler',
  'pages.schemaPipeline.createSchemaPipeline': 'Create Schema pipeline',
  'pages.service.createService': 'Create Service',
  'pages.serviceBuild.createBuildServiceVersionResponse': 'Create Service Build',
  'pages.serviceEvent.createServiceEvent': 'Create Service event type',
  'pages.serviceParams.createServiceParams': 'Create Service parameter template',
  'pages.serviceRun.createRunServiceVersionResponse': 'Create Service Run',
  'pages.serviceType.createServiceType': 'Create Service type',
  'pages.serviceVersion.createServiceVersion': 'Create Service version',
  'pages.serviceVersionBuild.createBuildServiceVersionResponse': 'Create Service Version Build',
  'pages.serviceVersionRun.createRunServiceVersionResponse': 'Create Service Version Run',
  'pages.shareContextStorage.createShareContextStorage': 'Create Shared context storage',
  'pages.subject.createSubject': 'Create Subject',
  'pages.subjects.createSubject': 'Create subjects',
  'pages.subjectType.createSubjectType': 'Create Subject type',
  'pages.subjectTypes.createSubjectType': 'Create Subject type',
  'pages.testPipeline.createTestPipeline': 'Create Test pipeline',
  'pages.testResultPipeline.createTestResultPipeline': 'Create Test pipeline result',
  'pages.tuneModel.createTuneModel': 'Create Fine-tuning job',
  'pages.tuneModelResult.createTuneModelResult': 'Create Tune model result',
  'pages.typeProviderContext.createTypeProviderContexts': 'Create Provider context type',
  'pages.typeSubjectCommunication.createTypeSubjectCommunication':
    'Create Communication subject type',
  'pages.user.createUser': 'Create User',
  'pages.userContext.createUserContextItem': 'Create User context',
  'pages.userOrganizationStructure.createUserOrganizationStructure':
    'Create User in organization structure',
  'pages.versionProviderContext.createVersionProviderContext': 'Create Provider context version',
  'pages.promptTemplates.title': 'Prompt templates',
  'pages.promptTemplates.description':
    'Choose a category and a classifier node, then a language, and set the prompt template text for it. Each node keeps one template per language.',
  'pages.promptTemplates.statusExists': 'Has template',
  'pages.promptTemplates.statusMissing': 'No template',
  'pages.promptTemplates.classifiers': 'Classifiers',
  'pages.promptTemplates.category': 'Group classifier category',
  'pages.promptTemplates.search': 'Search the tree',
  'pages.promptTemplates.emptyTree': 'No classifiers in this category',
  'pages.promptTemplates.notFound': 'Nothing found',
  'pages.promptTemplates.template': 'Prompt template',
  'pages.promptTemplates.selectNode': 'Select a tree node on the left',
  'pages.promptTemplates.noLanguages': 'No languages',
  'pages.promptTemplates.placeholder': 'Prompt template text',
  'pages.promptTemplates.create': 'Create',
  'pages.promptTemplates.save': 'Save',
  'pages.promptTemplates.reset': 'Discard changes',
  'pages.promptTemplates.delete': 'Delete',
  'pages.promptTemplates.cancel': 'Cancel',
  'pages.promptTemplates.deleteConfirm': 'Delete the template for this language?',
  'pages.promptTemplates.created': 'Template created',
  'pages.promptTemplates.saved': 'Template saved',
  'pages.promptTemplates.deleted': 'Template deleted',
  'pages.promptTemplates.unsavedTitle': 'You have unsaved changes',
  'pages.promptTemplates.unsavedContent':
    'If you continue, changes to the template text will be lost.',
  'pages.promptTemplates.discard': 'Continue without saving',
  'pages.promptTemplates.stay': 'Stay',
};
